import { Tag, Typography } from "antd";
import React from "react";

interface JobApplicationProfileMatchResultItemProps {
  topic: string;
  description: string;
  aiResponse: string;
  status: "matched" | "unmatched" | "partial";
}

const JobApplicationProfileMatchResultItem: React.FC<
  JobApplicationProfileMatchResultItemProps
> = ({ topic, description, aiResponse, status }) => {
  const tagColor =
    status === "matched" ? "green" : status === "unmatched" ? "red" : "orange";

  const matchItemClass =
    status === "matched"
      ? "success-header"
      : status === "unmatched"
      ? "error-header"
      : "warning-header";

  return (
    <div className="job-application-profile-match-result-item">
      <div
        className={`job-application-profile-match-result-item-header ${matchItemClass}`}
      >
        <Typography.Title level={5} style={{ margin: 0 }}>
          {topic}
        </Typography.Title>
        <Typography.Text style={{ fontWeight: 300 }}>
          {description}
        </Typography.Text>
      </div>

      <div className="job-application-profile-match-result-item-ai-response-container">
        <div className="job-application-profile-match-result-item-ai-response-header">
          <Typography.Text strong>AI Analysis Insights</Typography.Text>
          <Tag color={tagColor}>
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </Tag>
        </div>
        <div className="job-application-profile-match-result-item-ai-response-content">
          <div className="job-application-profile-match-result-item-ai-response-icon-container ai-icon-shine-container">
            <img
              src="/icons/ai-stars.svg"
              alt="ai icon"
              className="ai-icon-shine"
            />
          </div>
          <Typography.Text>{aiResponse}</Typography.Text>
        </div>
      </div>
    </div>
  );
};

export default JobApplicationProfileMatchResultItem;
